import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  // runnersubList:[],
};

export default function RunnerSubscriptionsReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case actionTypes.FETCH_RUNNER_SUBSRIPTION_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        runnersubList: action.payload.rows,
        runnersubCount: action.payload.count,
      };
    case actionTypes.FETCH_CARGOSIZE_LIST_SUCCESS_ACTION:
      return {
        ...state,
        cargoList: action.payload.rows,
      };
    case actionTypes.FETCH_HISTORYRUNNER_SUBSRIPTION_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        historyrunnersubList: action.payload.rows,
        historyrunnersubCount: action.payload.count,
      };

    case actionTypes.FETCH_RUNNER_SUBSRIPTION_INIT_ACTION:
      return {
        ...state,
        processing: true,
      };

    case actionTypes.FETCH_HISTORYRUNNER_SUBSRIPTION_INIT_ACTION:
      return {
        ...state,
        processing: true,
      };
      case actionTypes.FETCH_RUNNERSUBSCRIPTION_LOG_SUCCESS_ACTION:
        return {
          ...state,
          subsrptnRunnerLogList: action.payload.rows,
          subsrptnRunnerLogCount: action.payload.count,
        };

        case actionTypes.CLEAR_RUNNERSUBSCRIPTIONLOG_ACTION:
          return {
            ...state,
            subsrptnRunnerLogList: [],
          };

    default:
      return {
        ...state,
      };
  }
}
